import { AppState } from '../reducers';
import { createSelector } from 'reselect';

export const getAdvancedSearchState = (state: AppState) => state.advancedSearch;

export const getAdvancedSearchResults = createSelector(
    [getAdvancedSearchState],
    (advancedSearchState) => advancedSearchState.resultsLoading ? [] : advancedSearchState.results,
);